import React from 'react'
import { clearToken } from 'colleague-auth'

class SignOut extends React.Component {
  constructor() {
    super()
    this.signOutHandler = this.signOutHandler.bind(this)
    this.clearToken = clearToken.bind(this)
  }

  signOutHandler(e) {
    e.preventDefault()
    this.clearToken()
    window.location = sessionStorage.getItem('logoutUrl')
  }
  render() {
    return (
      <div className="ln-c-topbar__item">
        <a
          className="ln-o-bare-link ln-c-topbar__text"
          href=""
          id="logout"
          aria-selected="true" role="tab"
          aria-controls="logout" onClick={e => this.signOutHandler(e)}
        >Logout
        </a>
      </div>
    )
  }
}

export default SignOut



// WEBPACK FOOTER //
// ./src/components/SignOut/index.jsx